import { JsonapiEntity, entity } from '@talisdev/jsonapi-transformers';

@entity({ type: 'roles' })
export class RoleRecord extends JsonapiEntity<RoleRecord> {}
